<template>
</template>

<script>

export default {
	name: 'dinkTalk',
	data() {
		return {
			loading: '',
		}
	},
	mounted() {
		this.loading = this.$loading({
			lock: true,
			text: this.$t('dingTalkLoading'),
			spinner: 'el-icon-loading',
			background: 'rgba(255, 255, 255, 1)'
		});
		this.dingTalkLogin();
	},
	methods: {
		dingTalkLogin() {
			let vm = this;
			this.$http({
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
					'X-Requested-With': 'XMLHttpRequest'
				},
				method: 'post',
				url: '/yto-portal/portal/auth/login/dingTalk',
				params: {
					code: vm.$route.query.code
				}
			}).then(function ({data}) {
				if (data.success === true) {
					localStorage.setItem('loginMethod', JSON.stringify('钉钉扫码登录'));
					window.location = '/yto-portal/index/index.do';
				} else {
					vm.loading.close();
					vm.$alert(vm.$t(data.code), vm.$t('el.messagebox.title'), {
						confirmButtonText: vm.$t('el.colorpicker.confirm'),
						type: 'error',
						callback: action => {
							window.location = '/';
						}
					});
				}
			}).catch(function () {
				vm.loading.close();
				vm.$alert(vm.$t('CREDENTIAL_TOKEN_DINGTALK_INVALID'), vm.$t('el.messagebox.title'), {
					confirmButtonText: vm.$t('el.colorpicker.confirm'),
					type: 'error',
					callback: action => {
						window.location = '/';
					}
				});
			});
		},

	},
}

</script>

<style>
.el-loading-spinner i {
	color: #762ADB !important;
}

.el-loading-spinner .el-loading-text {
	color: #762ADB !important;
}
</style>
